import React from "react";
import { useTranslation } from "react-i18next";
import { MailOpen } from "lucide-react";

/** Hero shown in the thread pane before a conversation is selected. */
export const EmptyThreadState: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 bg-muted/30 p-8 text-center animate-fade-in">
			<div className="flex h-16 w-16 items-center justify-center rounded-sm border border-border bg-card shadow-card">
				<MailOpen className="h-7 w-7 text-muted-foreground" />
			</div>
			<h3 className="text-lg font-semibold text-foreground">
				{t("inbox.empty.selectConversationTitle", "Select a conversation")}
			</h3>
			<p className="max-w-xs text-sm text-muted-foreground">
				{t(
					"inbox.empty.selectConversationDescription",
					"Choose a conversation on the left to read and reply — email, LinkedIn and WhatsApp in one place."
				)}
			</p>
		</div>
	);
};
